import React, { Fragment } from 'react';
import html5 from './HTML5.jpg';
import css3 from './CSS3.jpg';
import javascript from './JavaScript.jpg';
import bootstrap from './Bootstrap.jpg';
import jquery from './jQuery.jpg';
import sass from './Sass.jpg';
import reactjs from './React JS.jpg';
import redux from './Redux.jpg';
import python from './Python.jpg';
import github from './Github.jpg';
import php from './PHP.jpg';
import mysql from './MySQL.jpg';
import './estilosComponente.css';
import './mediaqueriesComponente.css';

const Deslizador =()=>{

    const handleClickUno =()=>{

        const destruirDos = document.getElementById("deslizador-dos");
        const destruirTres = document.getElementById("deslizador-tres");
        const destruirCuatro = document.getElementById("deslizador-cuatro");
        const llamarUno = document.getElementById("deslizador-uno");
        
        const botonDos = document.getElementById("boton-dos");
        const botonTres = document.getElementById("boton-tres");
        const botonCuatro = document.getElementById("boton-cuatro");
        const botonUno = document.getElementById("boton-uno");

        destruirDos.style.display='none';
        destruirTres.style.display='none';
        destruirCuatro.style.display='none';
        llamarUno.style.display='flex';

        botonDos.style.backgroundColor='#192231';
        botonDos.style.border='none';
        botonTres.style.backgroundColor='#192231';
        botonTres.style.border='none';
        botonCuatro.style.backgroundColor='#192231';
        botonCuatro.style.border='none';
        botonUno.style.backgroundColor='#2e4161';
        botonUno.style.border='3px solid #fff';
    };

    const handleClickDos =()=>{

        const destruirUno = document.getElementById("deslizador-uno");
        const destruirTres = document.getElementById("deslizador-tres");
        const destruirCuatro = document.getElementById("deslizador-cuatro");
        const llamarDos = document.getElementById("deslizador-dos");

        const botonUno = document.getElementById("boton-uno");
        const botonTres = document.getElementById("boton-tres");
        const botonCuatro = document.getElementById("boton-cuatro");
        const botonDos = document.getElementById("boton-dos");

        destruirUno.style.display='none';
        destruirTres.style.display='none';
        destruirCuatro.style.display='none';
        llamarDos.style.display='flex';

        botonUno.style.backgroundColor='#192231';
        botonUno.style.border='none';
        botonTres.style.backgroundColor='#192231';
        botonTres.style.border='none';
        botonCuatro.style.backgroundColor='#192231';
        botonCuatro.style.border='none';
        botonDos.style.backgroundColor='#2e4161';
        botonDos.style.border='3px solid #fff';
    };

    const handleClickTres =()=>{

        const destruirUno = document.getElementById("deslizador-uno");
        const destruirDos = document.getElementById("deslizador-dos");
        const destruirCuatro = document.getElementById("deslizador-cuatro");
        const llamarTres = document.getElementById("deslizador-tres");

        const botonUno = document.getElementById("boton-uno");
        const botonDos = document.getElementById("boton-dos");
        const botonCuatro = document.getElementById("boton-cuatro");
        const botonTres = document.getElementById("boton-tres");

        destruirUno.style.display='none';
        destruirDos.style.display='none';
        destruirCuatro.style.display='none';
        llamarTres.style.display='flex';

        botonUno.style.backgroundColor='#192231';
        botonUno.style.border='none';
        botonDos.style.backgroundColor='#192231';
        botonDos.style.border='none';
        botonCuatro.style.backgroundColor='#192231';
        botonCuatro.style.border='none';
        botonTres.style.backgroundColor='#2e4161';
        botonTres.style.border='3px solid #fff';
    };

    const handleClickCuatro =()=>{
        
        const destruirUno = document.getElementById("deslizador-uno");
        const destruirDos = document.getElementById("deslizador-dos");
        const destruirTres = document.getElementById("deslizador-tres");
        const llamarCuatro = document.getElementById("deslizador-cuatro");

        const botonUno = document.getElementById("boton-uno");
        const botonDos = document.getElementById("boton-dos");
        const botonTres = document.getElementById("boton-tres");
        const botonCuatro = document.getElementById("boton-cuatro");

        destruirUno.style.display='none';
        destruirDos.style.display='none';
        destruirTres.style.display='none';
        llamarCuatro.style.display='flex';

        botonUno.style.backgroundColor='#192231';
        botonUno.style.border='none';
        botonDos.style.backgroundColor='#192231';
        botonDos.style.border='none';
        botonTres.style.backgroundColor='#192231';
        botonTres.style.border='none';
        botonCuatro.style.backgroundColor='#2e4161';
        botonCuatro.style.border='3px solid #fff';
    };

    return(
        <Fragment>

            <div id='deslizador-uno'>
                <img 
                src={html5} 
                id="image-programacion" 
                alt="HTML5 logo"/>
                <img 
                src={css3} 
                id="image-programacion" 
                alt="CSS3 logo"/>
                <img 
                src={javascript} 
                id="image-programacion" 
                alt="Javascript logo"/>
            </div>

            <div id='deslizador-dos'>
                <img 
                src={bootstrap} 
                id="image-programacion" 
                alt="Bootstrap logo"/>
                <img 
                src={jquery} 
                id="image-programacion" 
                alt="jQuery logo"/>
                <img 
                src={sass} 
                id="image-programacion" 
                alt="SASS logo"/>
            </div>

            <div id='deslizador-tres'>
                <img 
                src={reactjs} 
                id="image-programacion" 
                alt="React JS logo"/>
                <img 
                src={redux} 
                id="image-programacion" 
                alt="Redux logo"/>
                <img 
                src={python} 
                id="image-programacion" 
                alt="Python logo"/>
            </div>

            <div id='deslizador-cuatro'>
                <img 
                src={github} 
                id="image-programacion" 
                alt="Github"/>
                <img 
                src={php} 
                id="image-programacion" 
                alt="Google Search logo"/>
                <img 
                src={mysql} 
                id="image-programacion" 
                alt="Google Analytics logo"/>
            </div>

            <div id='contenedor-boton'>
                <button 
                onClick={handleClickUno} 
                id='boton-uno'>1</button>
                <button 
                onClick={handleClickDos} 
                id='boton-dos'>2</button>
                <button 
                onClick={handleClickTres} 
                id='boton-tres'>3</button>
                <button 
                onClick={handleClickCuatro} 
                id='boton-cuatro'>4</button>
            </div>
            
        </Fragment>
    );
};

export default Deslizador;